import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS, SERVICES } from "../../lib/content";
import { Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden bg-[#0A1F44] text-white"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#C9A227]/60 to-transparent" />
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-20 lg:grid-cols-12 lg:px-8 lg:py-28">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <div className="rounded-sm bg-white p-2">
              <img src={BRAND.logoUrl} alt="Accrue Metrics" className="h-12 w-12 object-contain" />
            </div>
            <div>
              <div className="font-serif text-2xl font-semibold tracking-tight text-white">
                Accrue <span className="text-[#C9A227]">Metrics</span>
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-white/60">
                {BRAND.tagline}
              </div>
            </div>
          </div>
          <p className="mt-6 max-w-md font-serif text-2xl leading-snug text-white/80">
            We staff the back office of modern CPA firms — quietly, accurately, on time.
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/70">
            <div className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-[#C9A227]" />
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email-link"
                className="hover:text-white"
              >
                {BRAND.email}
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-[#C9A227]" />
              <a
                href={`tel:${BRAND.phone.replace(/[^0-9+]/g, "")}`}
                data-testid="footer-phone-link"
                className="hover:text-white"
              >
                {BRAND.phone}
              </a>
            </div>
                      </div>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-[0.22em] text-[#C9A227]">Navigate</div>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-nav-${l.label.toLowerCase()}`}
                  className="text-sm text-white/75 transition-colors hover:text-[#C9A227]"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-[#C9A227]">Services</div>
          <ul className="mt-5 space-y-3">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link
                  to="/services"
                  data-testid={`footer-service-${s.id}`}
                  className="text-sm text-white/75 transition-colors hover:text-[#C9A227]"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-[0.22em] text-[#C9A227]">Compliance</div>
          <ul className="mt-5 space-y-2 text-sm text-white/75">
            <li>SOC 2 Type II Aligned</li>
            <li>GDPR-Ready Workflows</li>
            <li>NDA on every engagement</li>
            <li>U.S. & India Delivery</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-6 text-xs text-white/50 lg:flex-row lg:px-8">
          <div>© {new Date().getFullYear()} Accrue Metrics. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <span>Privacy</span>
            <span>Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
